import Link from 'next/link';

import { Box, Button, Group, Text } from '@mantine/core';

import { ProjectHelpers } from 'helpers/ProjectHelpers';
import { TextHelpers } from 'helpers/TextHelpers';

import { useRecentProjects } from 'hooks/use-recent-projects';

const RecentProjects = () => {
    const { recentProjects } = useRecentProjects();

    return (
        <Box ml={50} mt={-8}>
            <Text fz="sm" fw={500} mb={4}>
                Recent
            </Text>
            <Group gap={4}>
                <Button size="xs" component={Link} href={ProjectHelpers.urls.create()}>
                    + Create New Project
                </Button>
                {recentProjects.slice(0, 4).map((project) => (
                    <Button
                        key={project.id}
                        size="xs"
                        component="a" // don't user Next.js Link for diagram state issues
                        href={ProjectHelpers.urls.editor(project.combinedSlug)}
                        variant="default"
                    >
                        {TextHelpers.getTextWithEllipsis(project.name, 24)}
                    </Button>
                ))}
            </Group>
        </Box>
    );
};

export { RecentProjects };
